// Actions
import * as actions from '../reducers/session/sessionActions';
import { closeModal } from '../reducers/modal/modalActions';

// Selectors
import {
  sessionHydrated,
  selectSessionData,
} from '../reducers/session/sessionSelectors';

export const SessionListeners = {
  'persist/REHYDRATE': ({ dispatch, getState }, action) => {
    if (
      action.key === 'session' &&
      sessionHydrated(getState()) &&
      action.payload &&
      action.payload.data
    ) {
      const currentSessionData = selectSessionData(getState());
      if (
        currentSessionData &&
        currentSessionData.latestAccessTime <
          action.payload.data.latestAccessTime
      ) {
        dispatch(closeModal('SessionWarningModal'));
        dispatch(actions.updateSession({ ...action.payload.data }));
      }
    }
    return action;
  },
};

const SessionMiddleware = store => next => action => {
  if (SessionListeners[action.type])
    return next(SessionListeners[action.type](store, action));
  return next(action);
};

export default SessionMiddleware;
